import styled from 'styled-components';

export const StyledControlPanelLayout = styled.div`
  height: calc(100vh - 120px);
  overflow-y: auto;
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  padding: 20px;
`;
